import React from "react";
import InputDefault from "./InputDefault";
import InputPassword from "./InputPassword";
import './input.css';

const Input = ({
  disabled,
  onChange,
  value,
  name,
  variant,
  error,
  success,
  mask,
  onBlur,
  placeholder,
  label,
  labelColor,   // 👈 nueva prop
  maxLength,
  icon,
  iconPosition,
  autoFocus,
  handleKeyDown,
  classNames,
  onClick,       // 👈 añade
  readOnly,      // 👈 añade
}) => {
  return (
    <div className={`input-container-wrapper ${classNames}`}>
      {variant === "Simple" || !variant ? (
        <InputDefault
          name={name}
          value={value}
          label={label}
          labelColor={labelColor}
          onChange={onChange}
          onClick={onClick}       // 👈 lo pasamos
          readOnly={readOnly}     // 👈 lo pasamos
          placeholder={placeholder}
          disabled={disabled}
          mask={mask}
          maxLength={maxLength}
          onBlur={onBlur}
          error={error}
          success={success}
          icon={icon}
          iconPosition={iconPosition}
          autoFocus={autoFocus}
          handleKeyDown={handleKeyDown}
        />
      ) : null}

      {variant === "Password" ? (
        <InputPassword
          name={name}
          value={value}
          label={label}
          labelColor={labelColor}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          onBlur={onBlur}
          error={error}
          success={success}
        />
      ) : null}

      {error ? <p style={{ color: "red" }}>{error}</p> : null}
    </div>
  );
};

export default Input;